import React, { useState, useRef } from 'react';
import LinkWithQuery from '../LinkWithQuery';
import SubHeader from './SubHeader';
import MobileHeader from './MobileHeader';

const NavBar = () => {
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	const [activeMobileMenuId, setActiveMobileMenuId] = useState(null);
	const [activeId, setActiveId] = useState(null);
	const isMouseEntered = useRef(false);

	const handleHover = (event) => {
		if (event && event.target && event.target.dataset && event.target.dataset.headerMenuId) {
			setActiveId(event.target.dataset.headerMenuId);
		}

		isMouseEntered.current = true;
	};

	const handleHoverOut = () => {
		isMouseEntered.current = false;

		setTimeout(() => {
			if (isMouseEntered.current) return;
			setActiveId(null);
		}, 50);
	};

	const handleMobileMenuSelect = (event) => {
		if (event.target.dataset.headerMenuId === activeMobileMenuId) {
			setActiveMobileMenuId(null);
		} else {
			setActiveMobileMenuId(event.target.dataset.headerMenuId);
		}
	};

	return (
		<>
			<nav
				className={`c-navbar ${isMouseEntered.current ? 'is-hovered' : ''}`}
				style={!mobileMenuOpen ? { borderBottom: '1px solid #f2f2f2' } : {}}
			>
				<div className="o-wrapper">
					<div className="c-navbar__content">
						<LinkWithQuery to="/" className="c-navbar__logo">
							<img
								className="o-fluid-img"
								src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/logos/hearcom.svg"
								alt="hear.com logo"
							/>
						</LinkWithQuery>
						<div className="c-navbar__phone-icon">
							<a href="tel:17865260602">
								<img
									className="o-fluid-img"
									src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/icon-phone-round.svg"
									alt="hear.com phone number"
								/>
							</a>
						</div>
						<button
							className={`c-burger ${mobileMenuOpen ? 'is-active' : ''}`}
							onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
							aria-label="Burger menu"
						>
							<div className="c-burger__inner">
								<span className="c-burger__bar"></span>
								<span className="c-burger__bar"></span>
								<span className="c-burger__bar"></span>
							</div>
						</button>
						<ul className="c-navbar__nav">
							<li className="c-navbar__nav-item">
								<LinkWithQuery
									to="/hearing-aids/"
									className={`c-navbar__nav-item-link ${activeId === 'Hearing-Aids' ? 'is-active' : ''}`}
									data-header-menu-id="Hearing-Aids"
									onMouseMove={handleHover}
									onMouseLeave={handleHoverOut}
								>
									<span>Hearing Aids</span>
								</LinkWithQuery>
								<div
									className="c-navbar__nav-item-bridge"
									onMouseMove={handleHover}
									onMouseLeave={handleHoverOut}
								></div>
							</li>
							<li className="c-navbar__nav-item">
								<LinkWithQuery
									to="/hearing-loss/"
									className={`c-navbar__nav-item-link ${activeId === 'Hearing-Loss' ? 'is-active' : ''}`}
									data-header-menu-id="Hearing-Loss"
									onMouseMove={handleHover}
									onMouseLeave={handleHoverOut}
								>
									<span>Hearing Loss</span>
								</LinkWithQuery>
								<div
									className="c-navbar__nav-item-bridge"
									onMouseMove={handleHover}
									onMouseLeave={handleHoverOut}
								></div>
							</li>
							<li className="c-navbar__nav-item">
								<LinkWithQuery
									to="/resources/"
									className={`c-navbar__nav-item-link ${activeId === 'Resources' ? 'is-active' : ''}`}
									data-header-menu-id="Resources"
									onMouseMove={handleHover}
									onMouseLeave={handleHoverOut}
								>
									<span>Resources</span>
								</LinkWithQuery>
								<div
									className="c-navbar__nav-item-bridge"
									onMouseMove={handleHover}
									onMouseLeave={handleHoverOut}
								></div>
							</li>
							<li className="c-navbar__nav-item">
								<LinkWithQuery
									to="/about-us/"
									className={`c-navbar__nav-item-link ${activeId === 'About-Us' ? 'is-active' : ''}`}
									data-header-menu-id="About-Us"
									onMouseMove={handleHover}
									onMouseLeave={handleHoverOut}
								>
									<span>About Us</span>
								</LinkWithQuery>
								<div
									className="c-navbar__nav-item-bridge"
									onMouseMove={handleHover}
									onMouseLeave={handleHoverOut}
								></div>
							</li>
							<li className="c-navbar__nav-item">
								<a href="tel:17865260602" className="c-navbar__nav-item-link c-navbar__nav-item-link--phone">
									(786) 526-0602
								</a>
							</li>
						</ul>
					</div>
				</div>
				<SubHeader onMouseMove={handleHover} onMouseLeave={handleHoverOut} activeId={activeId} />
				<div className="c-navbar__bg-tint"></div>
			</nav>
			<MobileHeader
				mobileMenuOpen={mobileMenuOpen}
				activeMobileMenuId={activeMobileMenuId}
				handleMobileMenuSelect={handleMobileMenuSelect}
			/>
		</>
	);
};

export default NavBar;
